<ng-container [formGroup]="formGroup" >
  <mat-form-field class="flex-form">
    <input [matAutocomplete]="autoStore"
      formControlName="store"
      [id]="id"
      matInput
      placeholder="{{chooseStoreLabel | async}}" type="text">
    @if (required && formGroup.get('store').errors?.required) {
      <mat-error>
        {{storeNameRequiredLabel | async}}
      </mat-error>
    }
  </mat-form-field>

  <mat-autocomplete #autoStore="matAutocomplete" [displayWith]="displayStoreName" (optionSelected)="onStoreSelectedInternal($event.option.value)">
    @if (isLoading) {
      <mat-option class="is-loading">
        <mat-spinner diameter="50"></mat-spinner>
      </mat-option>
    }
    @if (!isLoading) {
      @for (store of filteredStores; track store) {
        <mat-option [value]="store">
          <span>{{ store.storeName }}</span>
          <small> | {{'No.' | translate}}: {{store.storeNumber}}</small>
        </mat-option>
      }
    }
  </mat-autocomplete>
</ng-container>
